import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import ol_Overlay from 'ol/Overlay';
import Map from 'ol/Map';
import Select from 'ol/interaction/Select';
import ol_style_Circle from 'ol/style/Circle';
import ol_style_Stroke from 'ol/style/Stroke';
import ol_style_Fill from 'ol/style/Fill';
import ol_style_Text from 'ol/style/Text';
import ol_source_Cluster from 'ol/source/Cluster';
import ol_source_Vector from 'ol/source/Vector';
import ol_source_TileWMS from 'ol/source/TileWMS';
import ol_source_ImageWMS from 'ol/source/ImageWMS';
import TileGrid from 'ol/tilegrid/TileGrid';
import * as Extent from 'ol/extent.js';
import { get as getProjection } from 'ol/proj';
import { getWidth } from 'ol/extent';

import ol_layer_Vector from 'ol/layer/Vector';
import Style from 'ol/style/Style';
import GeoJSON from 'ol/format/GeoJSON';
import ol_layer_Tile from 'ol/layer/Tile';
import ol_layer_Image from 'ol/layer/Image';
import ol_source_XYZ from 'ol/source/XYZ';
import Icon from 'ol/style/Icon';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Draw from 'ol/interaction/Draw.js';
import Circle from 'ol/geom/Circle.js';
import { Cluster, OSM } from 'ol/source';
import * as proj from 'ol/proj';
import Polyline from 'ol/format/Polyline';
import Polygon from 'ol/geom/Polygon';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill'
import condition from 'ol/events/condition';
import RegularShape from 'ol/style/RegularShape';
import LineString from 'ol/geom/LineString';
import ZoomSlider from 'ol/control/ZoomSlider';
import ScaleLine from 'ol/control/ScaleLine';
import Projection from 'ol/proj/Projection';
import Collection from 'ol/Collection';
import View from 'ol/View';
import { MapAbstractService } from './map-abstract.service';
import { LoggerService } from '../../../log/logger.service';
import { AwgLayers, AwgXYZLayer, AwgImageWmsLayer, AwgVectorLayer, FeatureMap, AwgWmsLayer } from '../../../model/layer.model';
import { Constants } from '../../../constants/constants';
import ol_source_BingMaps from 'ol/source/BingMaps'

import { Circle as CircleStyle } from 'ol/style.js';

let styleList = [];
let styleListJson = [];
let styleCategory = "";
let defaultStyle = undefined;

declare var $: any;
let min;
let max;


@Injectable()
export class MapService extends MapAbstractService {

  baseProjection: string = 'EPSG:3857';
  initViewToCoordinate: boolean;
  lon: string;
  lat: string;
  tk: string;

  meteoAttivo: boolean = false;

  public updatePositionOverlay(coordinate) {
    if (!this.selectionMode && this.overlay)
      this.overlay.setPosition(coordinate);
  }


  overlay: ol_Overlay;
  map: Map;

  constructor(private http: HttpClient,
    private logger: LoggerService) {
    super();
  }

  createMap() {
    this.map = new Map({
      target: 'mapViewer',
      layers: [],
      pixelRatio: 1,
      view: new View({
        projection: this.baseProjection
      })
    })


    let zoomslider = new ZoomSlider();
    let scaleLineControl = new ScaleLine();
    this.map.addControl(zoomslider);
    this.map.addControl(scaleLineControl);
    defaultStyle = this.createCircleStyle("grey", "white");

    this.map.on('click', (e) => {
      let coord = e.coordinate;
      this.onClickMap({ coordinate: coord, event: e });
    });

    this.addVectorLayerIfNotExist("routeMarkerLayer", null, 200);
    this.addVectorLayerIfNotExist("routeLayer", null, 100)
  
  }

  setOpacity(value, name) {
    let layer = this.getLayerByName(name);
    layer.setOpacity(value);
  }

  public aggiungiVector(name: string, feature: any) {
    var draw = new Draw({
      type: "Circle",
      freehand: true
    });
    let geojsonObject = {
      'type': 'FeatureCollection',
      'crs': {
        'type': 'name',
        'properties': {
          'name': 'EPSG:3857'
        }
      },
      'features': [{
        'type': 'Feature',
        'geometry': {
          'type': 'Point',
          'coordinates': [0, 0]
        }
      }, {
        'type': 'Feature',
        'geometry': {
          'type': 'LineString',
          'coordinates': [[4e6, -2e6], [8e6, 2e6]]
        }
      }, {
        'type': 'Feature',
        'geometry': {
          'type': 'LineString',
          'coordinates': [[4e6, 2e6], [8e6, -2e6]]
        }
      }, {
        'type': 'Feature',
        'geometry': {
          'type': 'Polygon',
          'coordinates': [[[1566633.48048262, 5247863.56557561],
          [1566630.8659249, 5247860.1469643],
          [1566658.25578413, 5247813.82004953],
          [1566688.15676596, 5247856.27683411],
          [1566755.7877312, 5247951.01750621],
          [1566712.60624145, 5247973.92581444],
          [1566666.25741961, 5247909.11060614],
          [1566633.48048262, 5247863.56557561]
          ]]
        }
      }, {
        'type': 'Feature',
        'geometry': {
          'type': 'MultiLineString',
          'coordinates': [
            [[-1e6, -7.5e5], [-1e6, 7.5e5]],
            [[1e6, -7.5e5], [1e6, 7.5e5]],
            [[-7.5e5, -1e6], [7.5e5, -1e6]],
            [[-7.5e5, 1e6], [7.5e5, 1e6]]
          ]
        }
      }, {
        'type': 'Feature',
        'geometry': {
          'type': 'MultiPolygon',
          'coordinates': [
            [[[-5e6, 6e6], [-5e6, 8e6], [-3e6, 8e6], [-3e6, 6e6]]],
            [[[-2e6, 6e6], [-2e6, 8e6], [0, 8e6], [0, 6e6]]],
            [[[1e6, 6e6], [1e6, 8e6], [3e6, 8e6], [3e6, 6e6]]]
          ]
        }
      }, {
        'type': 'Feature',
        'geometry': {
          'type': 'GeometryCollection',
          'geometries': [{
            'type': 'LineString',
            'coordinates': [[-5e6, -5e6], [0, -5e6]]
          }, {
            'type': 'Point',
            'coordinates': [4e6, -5e6]
          }, {
            'type': 'Polygon',
            'coordinates': [[[1e6, -6e6], [2e6, -4e6], [3e6, -6e6]]]
          }]
        }
      }]
    };
    let image = new CircleStyle({
      radius: 5,
      fill: null,
      stroke: new Stroke({ color: 'red', width: 1 })
    });

    let styles = {
      'Point': new Style({
        image: image
      }),
      'LineString': new Style({
        stroke: new Stroke({
          color: 'green',
          width: 1
        })
      }),
      'MultiLineString': new Style({
        stroke: new Stroke({
          color: 'green',
          width: 1
        })
      }),
      'MultiPoint': new Style({
        image: image
      }),
      'MultiPolygon': new Style({
        stroke: new Stroke({
          color: 'yellow',
          width: 1
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 0, 0.1)'
        })
      }),
      'Polygon': new Style({
        stroke: new Stroke({
          color: 'blue',
          lineDash: [4],
          width: 3
        }),
        fill: new Fill({
          color: 'rgba(0, 0, 255, 0.1)'
        })
      }),
      'GeometryCollection': new Style({
        stroke: new Stroke({
          color: 'magenta',
          width: 2
        }),
        fill: new Fill({
          color: 'magenta'
        }),
        image: new CircleStyle({
          radius: 10,
          fill: null,
          stroke: new Stroke({
            color: 'magenta'
          })
        })
      }),
      'Circle': new Style({
        stroke: new Stroke({
          color: 'red',
          width: 2
        }),
        fill: new Fill({
          color: 'rgba(255,0,0,0.2)'
        })
      })
    };
    let styleFunction = function (feature) {
      return styles[feature.getGeometry().getType()];
    };
    let vectorSource = new ol_source_Vector({
      features: (new GeoJSON()).readFeatures(geojsonObject)
    });

    vectorSource.addFeature(new Feature(new Circle([5e6, 7e6], 1e6)));
    let vectorLayer = new ol_layer_Vector({
      source: vectorSource,
      style: styleFunction
    });
    //this.map.addLayer(vectorLayer);
    //esempio cluster
    var mapLayers = this.map.getLayers();
    var visible = false;
    //var appezzamenti=false;
    mapLayers.forEach(layer => {
      //if(layer.get('name').startsWith('appezzamenti')&& layer.get('visible'))
      // appezzamenti=true;
      if (layer.get('name') == name)
        visible = layer.get('visible');
    }
    );
    //if(name.startsWith("isole")&& appezzamenti && visible)
    //visible=false;
    var count = 20000;
    var features = new Array();
    var e = 4500000;
    for (var i = 0; i < feature.length; ++i) {
      //var coordinates = [2 * e * Math.random() - e, 2 * e * Math.random() - e];
      features[i] = new Feature(new Point(feature[i]));

    }/*
features[0] = new Feature(new Point([1541852.90033097, 5245495.34312422]));
features[1] = new Feature(new Point([1541759.60612176, 5245225.1534254]));
features[2] = new Feature(new Point([1541571.70606782, 5245389.91823303]));*/

    var source = new ol_source_Vector({
      features: features
    });

    var clusterSource = new Cluster({
      distance: parseInt('100', 10),
      source: source
    });
    var styleCache = {};
    var clusters = new ol_layer_Vector({
      source: clusterSource,
      //name: 'cluster',
      name: name + 'Cluster',
      visible: visible,
      style: function (feature) {
        var size = feature.get('features').length;
        var style = styleCache[size];
        if (!style) {
          style = new Style({
            image: new CircleStyle({
              radius: Math.min(50, 0.05 * size + 15),
              stroke: new Stroke({
                color: size > 1 ? '#fff' : 'rgba(255, 255, 255, 0.01)'
              }),
              fill: new Fill({
                //color: size>1?(name.startsWith('isole')?[51, 153, 204, 1]: [204, 102, 51,1]): 'rgba(255, 255, 255, 0.01)'
                color: size > 1 ? (name.startsWith('isole') ? [1, 154, 255, 0.5] : [1, 154, 255, 0.5]) : 'rgba(255, 255, 255, 0.01)'
                //color: size>0?(name.startsWith('isole')?[51, 153, 204, 1]: [204, 102, 51,Math.min(0.8, 0.5 + (size/100) )]): 'rgba(255, 255, 255, 0.01)'
              })
            }),
            text: new ol_style_Text({
              text: size.toString(),
              font: Math.min(20, 0.05 * size + 15) + 'px sans-serif',
              fill: new Fill({
                color: size > 1 ? '#fff' : 'rgba(255, 255, 255, 0.01)'
              })
            })
          });
          styleCache[size] = style;
        }
        return style;
      }
    });
    var raster = new ol_layer_Tile({
      source: new OSM()
    });
    //this.map.addLayer(raster);
    this.map.addLayer(clusters);

    this.map.on('moveend', this.onMoveEnd);

  }
  setZoomBing() {
    var mapLayers = this.map.getLayers();
    mapLayers.forEach(layer => {
      if (layer.get('name').startsWith('bingmaps') && layer.get('visible') && this.map.getView().getZoom() > 18) {
        this.map.getView().setZoom(19);
      }
    }
    );
  }

  onMoveEnd(evt) {
    var map = evt.map;
    var mapLayers = map.getLayers();
    if (map.getView().getZoom() > 12) {

      mapLayers.forEach(layer => {
        if (layer.get('name').endsWith('Cluster'))
          layer.setVisible(false);

        if (layer.get('name').startsWith('bingmaps') && layer.get('visible') && map.getView().getZoom() > 18) {
          map.getView().setZoom(19);
        }
      }
      );
    }
    else {
      var isole = false;
      var appezzamenti = false;
      mapLayers.forEach(layer => {
        if (layer.get('name').startsWith('isole') && !layer.get('name').endsWith('Cluster'))
          isole = layer.get('visible');
        if (layer.get('name').startsWith('appezzamenti') && !layer.get('name').endsWith('Cluster'))
          appezzamenti = layer.get('visible');
      }
      );
      mapLayers.forEach(layer => {
        if (layer.get('name').startsWith('isole') && layer.get('name').endsWith('Cluster'))
          layer.setVisible(isole);
        if (layer.get('name').startsWith('appezzamenti') && layer.get('name').endsWith('Cluster'))
          layer.setVisible(appezzamenti);
      }
      );
    }
  }
  ///
  public aggiungiPoligono(name: string, feature: any) {
    let geojsonObject = {
      'type': 'FeatureCollection',
      'crs': {
        'type': 'name',
        'properties': {
          'name': 'EPSG:3857'
        }
      },
      'features': [{
        'type': 'Feature',
        'geometry': {
          'type': 'MultiPolygon',
          'coordinates': feature
        }
      }]
    };
    let image = new CircleStyle({
      radius: 5,
      fill: null,
      stroke: new Stroke({ color: 'red', width: 1 })
    });

    let styles = {
      'Point': new Style({
        image: image
      }),
      'LineString': new Style({
        stroke: new Stroke({
          color: 'green',
          width: 1
        })
      }),
      'MultiLineString': new Style({
        stroke: new Stroke({
          color: 'green',
          width: 1
        })
      }),
      'MultiPoint': new Style({
        image: image
      }),
      'MultiPolygon': new Style({
        stroke: new Stroke({
          color: 'blue',
          width: 3
        })
      }),
      'Polygon': new Style({
        stroke: new Stroke({
          color: 'blue',
          lineDash: [4],
          width: 4
        })
      }),
      'GeometryCollection': new Style({
        stroke: new Stroke({
          color: 'magenta',
          width: 2
        }),
        fill: new Fill({
          color: 'magenta'
        }),
        image: new CircleStyle({
          radius: 10,
          fill: null,
          stroke: new Stroke({
            color: 'magenta'
          })
        })
      }),
      'Circle': new Style({
        stroke: new Stroke({
          color: 'red',
          width: 2
        }),
        fill: new Fill({
          color: 'rgba(255,0,0,0.2)'
        })
      })
    };
    let styleFunction = function (feature) {
      return styles[feature.getGeometry().getType()];
    };
    let vectorSource = new ol_source_Vector({
      features: (new GeoJSON()).readFeatures(geojsonObject)
    });

    let vectorLayer = new ol_layer_Vector({
      source: vectorSource,
      name: name,
      style: styleFunction
    });
    this.map.addLayer(vectorLayer);
  }
  ///
  public createOverlay(idTagElement: string, positioning: string, offset: number[]) {
    this.overlay = new ol_Overlay({
      element: document.getElementById(idTagElement),
      positioning: positioning,
      offset: offset
    });
    this.map.addOverlay(this.overlay);
  }

  /** add layer and set up selectable*/
  public addLayers(layersToCreate: Array<AwgLayers>) {

    for (const element of layersToCreate) {
      if (element.default_visible) {
        element.visible = true;
      }
      if (element.proj4Projection) {
      }

      switch (element.layer_type) {

        // XYZ
        case Constants.LAYER_TYPE_XYZ:
          const layerxyz = element as AwgXYZLayer;
          if (layerxyz.addToMapOnInit) {
            this.addTileXYZIfNotExist(layerxyz.name, layerxyz.url, layerxyz.zIndex, layerxyz, layerxyz.key, layerxyz.imagerySet);
          }
          break;

        // TileWMS
        case Constants.LAYER_TYPE_TileWMS:
          const layertilewms = element as AwgWmsLayer;
          if (layertilewms.addToMapOnInit) {
            this.addTileWMSIfNotExist(layertilewms.name, layertilewms);
          }
          break;

        // ImageWMS
        case Constants.LAYER_TYPE_ImageWMS:
          const layerimagewms = element as AwgImageWmsLayer;
          if (layerimagewms.addToMapOnInit) {
            this.addImageWMSIfNotExist(layerimagewms.name, layerimagewms);
          }
          break;

        // VECTOR
        case Constants.LAYER_TYPE_VECTOR:
          const layervector = element as AwgVectorLayer;

          if (layervector.addToMapOnInit) {
            this.addVectorLayerIfNotExist(layervector.name, null, layervector.zIndex, null, layervector.selectable);
          }
          if (layervector.selectable)
            this.addSelectionEvent(layervector);
          break;

      }

      this.toggleVisibleLayer(element.name, element.visible);
    }
  }

  setInitView(extent?: any, lon?: string, lat?: string, initViewToCoordinate?: boolean) {
    const view = this.map.getView();

    if (lon && lat)
      var coord = proj.fromLonLat([lat, lon], "EPSG:4326", "EPSG:3857")
    if (extent)
      view.fit(extent, this.map.getSize());
    else {
      view.setCenter(coord)
      view.setZoom(13);
    }
    this.selectLayerAppezzamentiOpacity0();
  }

  selectLayer(layerIn: any) {
    var mapLayers = this.map.getLayers();
    mapLayers.forEach(layer => {
      if (layer && layer.get('name') == 'appezzamenti') {

      }
    })
  }
  selectLayerAppezzamentiOpacity0() {
    var mapLayers = this.map.getLayers();
    mapLayers.forEach(layer => {
      if (layer && layer.get('name') == 'appezzamenti') {
      }
    })
  }

  addSelectionEvent(layervector: AwgVectorLayer) {
    if (layervector.selectable) {
      let layer = this.getLayerByName(layervector.name)

      let selectClick = new Select()
      this.selectInteractions.push(selectClick);

      this.map.addInteraction(selectClick);
      selectClick.on('select', (e) => {
        this.logger.info("Feature on click", e)

        let feature = e.selected[0];
        let coordsFeature = e.selected.length > 0 ? feature.getGeometry().getCoordinates() : null;
        let propFeature = e.selected.length > 0 ? feature.getProperties() : null;

        this.onSelectedFeature({
          coordinate: e.mapBrowserEvent.coordinate, coordFeature: coordsFeature,
          properties: propFeature
        });

      });
    }
  }

  createCircleStyle(fillColor: string, strokeColor: string) {
    return new Style({
      image: new ol_style_Circle({
        radius: 4,
        fill: new ol_style_Fill({ color: fillColor }),
        stroke: new ol_style_Stroke({ color: strokeColor, width: 1 })
      })
    })
  }

  fillStyleList(valueColor: string[]) {
    styleList = [];
    let filterValuesList = Object.keys(valueColor);
    filterValuesList.forEach(filterValue => {
      let style = defaultStyle;
      if (valueColor && valueColor[filterValue]) {
        style = this.createCircleStyle(valueColor[filterValue], "black");
      }
      styleList[filterValue.toUpperCase()] = style;
    });
  }


  setDefaultStyleToLayer(layerName: string) {
    this.map.getLayers().forEach(layer => {
      if (layer && layer.get('name') == layerName) {
        layer.setStyle(defaultStyle);
      }
    });
  }

  setStyleToLayer(layerName: string, style?: any) {
    this.map.getLayers().forEach(layer => {
      if (layer && layer.get('name') == layerName) {
        if (style) {
          layer.setStyle(style);
        }
        else {
          layer.setStyle(this.layerStyle);
        }
      }
    });
  }

  createVectorSource(geoJSON: any, dataProjection: string = 'EPSG:3857', featureProjection: string = 'EPSG:3857') {
    return new ol_source_Vector({
      features: geoJSON == null ? [] : (new GeoJSON()).readFeatures(geoJSON, {
        dataProjection: dataProjection,
        featureProjection: featureProjection
      })
    });
  }

  createVectorLayer(vectorSource: any, name: string, zIndex: number, style: any, selectable?: boolean, opacity?: number) {
    let styel = new Style({
      stroke: new ol_style_Stroke({
        color: 'blue',
        width: 3
      }),
      fill: new ol_style_Fill({
        color: 'rgba(0, 0, 255, 0.1)'
      })
    })

    return new ol_layer_Vector({
      source: vectorSource,
      style: style,
      name: name,
      zIndex: zIndex,
      selectable: selectable,
      opacity: opacity
    });
  }

  createTileXYZSource(url: any, options: any) {
    return new ol_source_XYZ({
      url: url,
      attributions: (options.attributions ? options.attributions : undefined),
      crossOrigin: (options.crossorigin ? options.crossorigin : undefined)
    });
  }

  createBingSource(key, imagerySet, options) {
    return new ol_source_BingMaps({
      key: key,
      imagerySet: imagerySet,
      crossOrigin: (options.crossorigin ? options.crossorigin : undefined)
    })
  }
  createTileLayer(tileSource: any, name: string, zIndex: number, extent?: number[], opacity?: string) {
    return new ol_layer_Tile({
      source: tileSource,
      name: name,
      extent: extent,
      zIndex: zIndex,
      //opacity: (opacity ? opacity : "1")
    });
  }


  createImageLayer(imageSource: any, name: string, zIndex: number, extent?: number[], opacity?: string) {
    return new ol_layer_Image({
      source: imageSource,
      name: name,
      extent: extent,
      zIndex: zIndex,
      //opacity: (opacity ? opacity : "1")

    });
  }

  setStyle(layerName: string, category: string, values: string[]) {
    this.logger.info("category: ", category, ' values: ', values);

    if (values && Object.keys(values).length) {
      styleCategory = category;
      this.fillStyleList(values);
      this.setStyleToLayer(layerName);
    } else {
      this.setDefaultStyleToLayer(layerName);
    }
  }

  layerStyle(feature) {
    if (feature && feature.get(styleCategory)) {
      let style = styleList[feature.get(styleCategory).toUpperCase()]
      return (style ? style : defaultStyle);
    } else {
      //console.error(" feature_error: "+styleCategory+" not found.");
      return defaultStyle;
    }
  }



  addLayerGeoJson(layerName: string, geoJSON: any, color?: string) {
    let style = color ? this.createCircleStyle(color, "white") : defaultStyle;
    let layerFound = this.getLayerByName(layerName);
    let vectorSource = this.createVectorSource(geoJSON);

    if (layerFound) {
      layerFound.setSource(vectorSource);
      layerFound.setStyle(style);
    } else {
      // per default utilizzo il colore blu
      let vectorLayer = this.createVectorLayer(vectorSource, layerName, 0, style);
      this.map.addLayer(vectorLayer);
    }
  }

  removeLayer(layerName: string) {
    var mapLayers = this.map.getLayers();
    mapLayers.forEach(layer => {
      if (layer && layer.get('name') == layerName) {
        this.map.removeLayer(layer);
      }
    });
  }

  removeLayerStartsWith(layerName: string) {
    var mapLayers = this.map.getLayers();
    mapLayers.forEach(layer => {
      if (layer && layer.get('name').startsWith(layerName)) {
        this.map.removeLayer(layer);
      }
    });
  }

  setZoom(zoom: Number) {
    const view = this.map.getView();

    view.setZoom(zoom);

  }
  addVectorLayerIfNotExist(layerName: string, geoJSON: any, zIndex: number = 0, style?: any, selectable?: boolean) {
    let foundLayer = false;
    for (const tmpLayer of this.map.getLayers().getArray()) {
      if (tmpLayer.get('name') === layerName) {
        foundLayer = true;
        break;
      }
    }
    if (!foundLayer) {
      let vectorSource = this.createVectorSource(geoJSON);
      let vectorLayer = this.createVectorLayer(vectorSource, layerName, zIndex, style, selectable);
      this.map.addLayer(vectorLayer);
    }
  }

  addTileXYZIfNotExist(layerName: string, url: any, zIndex: number = 0, options?: any, key?: string, imagerySet?: string) {
    let foundTileXYZ = false;
    for (const tmpLayer of this.map.getLayers().getArray()) {
      if (tmpLayer.get('name') === layerName) {
        foundTileXYZ = true;
        break;
      }
    }
    let xyzSource: any;
    if (!foundTileXYZ) {
      if (key && imagerySet) {
        xyzSource = this.createBingSource(key, imagerySet, options);

      } else {
        xyzSource = this.createTileXYZSource(url, options);
      }
      let tileLayer = this.createTileLayer(xyzSource, layerName, zIndex);
      this.map.addLayer(tileLayer);
    }
  }

  toggleVisibleLayer(layerName: string, visible: boolean) {
    for (const tmpLayer of this.map.getLayers().getArray()) {
      if (tmpLayer.get('name') === layerName) {
        tmpLayer.setVisible(visible);
        if (this.map.getView().getZoom() > 12 && tmpLayer.get('name').endsWith('Cluster'))
          tmpLayer.setVisible(false);
        if (tmpLayer.get('name').startsWith('meteo')) {
          this.meteoAttivo = tmpLayer.getVisible();
          this.setMeteoActive(tmpLayer.getVisible());
        }
        break;
      }
    }
  }
  getMeteoAttivo() {
    return this.meteoAttivo;
  }

  getLayerByName(layerName: string): any {
    for (const tmpLayer of this.map.getLayers().getArray()) {
      if (tmpLayer.get('name') === layerName) {
        return tmpLayer;
      }
    }
  }

  hexbin: any;
  binSize: any;
  styleFn: any;
  modify: any;
  layerSource: any;




  convertToEpsg(epsgFrom: string, epsgTo: string, coords: any) {
    return proj.transform([
      parseFloat(coords[0]), parseFloat(coords[1])
    ], epsgFrom, epsgTo);
  }

  createSourceTileWMS(url: string, params: any, serverType: string, projection: string, cors: string) {
    const proj = projection ? projection : undefined;
    var extent3067 = [-2170377, 3525769, 4888719, 6520859];
    var projExtent = getProjection('EPSG:3857').getExtent();
    var startResolution = getWidth(projExtent) / 256;

    var resolutions = new Array(20);
    for (var i = 0, ii = resolutions.length; i < ii; ++i) {
      resolutions[i] = startResolution / Math.pow(2, i);
    }
    var tileGrid = new TileGrid({
      extent: projExtent,
      resolutions: resolutions,
      tileSize: [256, 256],
      hidpi: false,
    });

    return new ol_source_TileWMS({
      url: url,
      params: params,
      serverType: serverType,
      tileGrid: tileGrid,
      projection: proj,
      crossOrigin: cors
    });
  }

  createSourceImageWMS(url: string, params: any, serverType: string, projection: string, cors: string) {
    const proj = projection ? projection : undefined;
    return new ol_source_ImageWMS({
      url: url,
      params: params,
      serverType: serverType,
      projection: proj,
      crossOrigin: cors
    });
  }

  oneHoursAgo(layerName: string) {
    var tenMinAgo = new Date(Date.now() - 60000 * 10 - 60000 * (new Date().getMinutes() % 10));//i 10 minti prima
    //var tenMinAgoAppr= new Date(Date.now()-60000*(new Date().getMinutes()%10));//i 10 minti prima
    //se temperature metto l'ora piena
    if (layerName.startsWith("temp")) {
      tenMinAgo = new Date(Date.now() - 3600000);//n'ora prima
      tenMinAgo.setMinutes(0);
    }
    tenMinAgo.setSeconds(0);
    tenMinAgo.setMilliseconds(0);
    return tenMinAgo;
  }
  now(layerName: string) {
    var tenMinAgo = new Date(Date.now());
    //var tenMinAgoAppr= new Date(Date.now()-60000*(new Date().getMinutes()%10));//i 10 minti prima
    //se temperature metto l'ora piena
    if (layerName.startsWith("temp")) {
      tenMinAgo = new Date(Date.now() - 60000 * 10 - 60000 * (new Date().getMinutes() % 10));//i 10 minti prima
      tenMinAgo = new Date(Date.now() - 3600000);//n'ora prima
      tenMinAgo.setMinutes(0);
      tenMinAgo.setSeconds(0);
      tenMinAgo.setMilliseconds(0);
    }

    return tenMinAgo;
  }

  addTileWMSIfNotExist(layerName: string, element: AwgWmsLayer) {

    // proj4.defs('EPSG:25832','+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs')
    // olproj4.set(proj4)

    let url = element.url;
  
    let params = {
      'LAYERS': element.layer,
      'VERSION': element.version,
      'FORMAT': (element.format ? element.format : 'image/png'),
      'TRANSPARENT': (element.transparent ? element.transparent : true),
      'TILED': (element.tiled ? element.tiled : true),
      'CRS': (element.crs ? element.crs : ''),
      'STYLES': (element.styles ? element.styles : ''),
      'TIME': this.oneHoursAgo(layerName).toISOString(),
    };

    let serverType = (element.serverType ? element.serverType : 'geoserver');
    let extent = (element.extent ? element.extent : this.map.getExtent());
    let featureInfo = (element.feature_info ? element.feature_info : null);
    let cors = (element.crossorigin ? element.crossorigin : null);
    console.log("cors="+cors);
    let projection = (element.proj4Projection && element.proj4Projection.epsg ? element.proj4Projection.epsg : null)

    let source = this.createSourceTileWMS(url, params, serverType, projection, cors);
    let layertileWMS = this.createTileLayer(source, layerName, element.zIndex, extent, element.opacity);

    if (featureInfo) {
      layertileWMS.set("feature_info", featureInfo);
    }

    if (element.proj4Projection) {
      layertileWMS.set("projection", element.proj4Projection);
    }

    this.map.addLayer(layertileWMS);
  }

  addImageWMSIfNotExist(layerName: string, element: AwgImageWmsLayer) {

    // proj4.defs('EPSG:25832','+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs')
    // olproj4.set(proj4)

    let url = element.url;
  
    let params = {
      'LAYERS': element.layer,
      'VERSION': element.version,
      'FORMAT': (element.format ? element.format : 'image/png'),
      'TRANSPARENT': (element.transparent ? element.transparent : true),
      'TILED': (element.tiled ? element.tiled : true),
      'CRS': (element.crs ? element.crs : ''),
      'STYLES': (element.styles ? element.styles : ''),
    };

    // if (element.ecql) {
    //   params['CQL_FILTER']=null;
    // }

    let serverType = (element.serverType ? element.serverType : 'geoserver');
    let extent = (element.extent ? element.extent : this.map.getExtent());
    let featureInfo = (element.feature_info ? element.feature_info : null);
    let cors = (element.crossorigin ? element.crossorigin : null);
    let projection = (element.proj4Projection && element.proj4Projection.epsg ? element.proj4Projection.epsg : null)

    let source = this.createSourceImageWMS(url, params, serverType, projection, cors);

    let layerImageWMS = this.createImageLayer(source, layerName, element.zIndex, extent, element.opacity);
    if (featureInfo) {
      layerImageWMS.set("feature_info", featureInfo);
    }
    if (element.proj4Projection) {
      layerImageWMS.set("projection", element.proj4Projection);
    }
    if (element.ecql) {
      layerImageWMS.set("ecql", element.ecql);
    }
    if (element.token_tk) {
      layerImageWMS.set("token_tk", element.token_tk)
    }
    //  if(element.name == 'isolecorpo'){
    //   console.log(layerImageWMS)
    // }
    this.map.addLayer(layerImageWMS);
  }

  flyTo(location) {
    let duration = 2000;
    let zoom = this.map.getView().getZoom() < 16 ? 16 : this.map.getView().getZoom();
    let parts = 2;
    let called = false;
    function callback(complete) {
      --parts;
      if (called) {
        return;
      }
      if (parts === 0) {
        called = true;
      }
    }
    this.map.getView().animate({
      center: location,
      duration: duration
    }, callback);
    this.map.getView().animate({
      zoom: zoom - 1,
      duration: duration / 2
    }, {
      zoom: zoom,
      duration: duration / 2
    }, callback);
  }

  createPolygonStyle(fillColor: string = 'blue', strokeColor: string = 'blue', width?: number) {
    return new Style({
      fill: new ol_style_Fill({ color: fillColor }),
      stroke: new ol_style_Stroke({ color: strokeColor, width: (width ? width : 1) }),
    });
  }

  addVectorLayerToMap(layer: any) {
    this.map.addLayer(layer);
  }

  getLayerAtPoint(evt: any) {
    let layers: any[] = [];
    var self = this;
    this.map.forEachLayerAtPixel(evt.pixel, function (layer) {
      layers.push(layer);
    });
    return layers;
  }

  setPropertiesToLayer(layerName: string, properties: any[]) {
    let layer = this.getLayerByName(layerName);
    //layer.setProperties(properties);
    properties.map(property => {
      layer.set(property['label'], property['value']);
    });

  }

  removeLayersByProperty(propertyName: string, propertyValue: string) {
    var layersToRemove = [];
    this.map.getLayers().forEach(function (layer) {
      if (layer && layer.get(propertyName) == propertyValue) {
        layersToRemove.push(layer);
      }
    });

    var len = layersToRemove.length;
    for (var i = 0; i < len; i++) {
      this.map.removeLayer(layersToRemove[i]);
    }
  }


  getMapResolution() {
    return this.map.getView().getResolution();
  }

  getMapBbox(epsgFrom: string, epsgTo: string) {

    if (this.map.getView()) {
      let extent = this.map.getView().calculateExtent(this.map.getSize());

      let coords25832_1 = proj.transform([
        parseFloat(extent[0]), parseFloat(extent[1])
      ], epsgFrom, epsgTo);
      let coords25832_2 = proj.transform([
        parseFloat(extent[2]), parseFloat(extent[3])
      ], epsgFrom, epsgTo);
      var coordtot = coords25832_1.concat(coords25832_2);

      return coordtot.join(',');

    }
    return null;
  }

  getProjFromCode(codice: string) {
    return new Projection({
      code: codice
    })

  }


  layerStyleJson(feature) {
    const propIdCategory = 'layer_category_id';
    if (feature && feature.get(propIdCategory)) {
      let style = styleListJson[feature.get(propIdCategory)]
      return (style ? style : defaultStyle);
    } else {
      return defaultStyle;
    }
  }


  getWMSLayersWithECQLOrTK() {
    let layers = [];
    this.map.getLayers().forEach(function (layer) {
      if (layer && (layer.get("ecql") || layer.get("token_tk"))) {
        layers.push(layer);
      }
    });
    return layers;
  }

  removeAllLayers() {

    let layersName = [];
    this.map.getLayers().getArray().forEach(layer => {
      layersName.push(layer.get('name'));
    })
    layersName.forEach(layerName => {
      this.removeLayer(layerName);
    });
    layersName = [];

  }

  updateParamstoAllWMS(objects: any[]) {
    let wmsWithEcql = this.getWMSLayersWithECQLOrTK();
    wmsWithEcql.forEach(layer => {
      let isPresent = false;
     
      if (objects && layer.get("ecql")) {
        objects.forEach(obj => {
          if (obj.layerName == layer.get("name") && obj.ecql) {

            layer.getSource().updateParams({ 'CQL_FILTER': obj.ecql });
            isPresent = true;
            return;
          }
        })

        if (!isPresent) {
          layer.getSource().updateParams({ 'CQL_FILTER': null });
        }

      }
      layer.getSource().refresh();

    });
  }
}

